class ReactFilterBoolean extends React.Component {

    constructor(props) {
        super(props);
        this.dropdownRef = React.createRef();
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        var value = this.dropdownRef.current.getValues();
        return {
            value: value
        };
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.dropdownRef.current.clearValues()
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if (values.value) {
            this.dropdownRef.current.setValues({
                value: values.value
            })
        } else {
            this.clearValues();
        }
    }

    render() {

        var value = this.props.settings.value;
        if (!value) {
            value = 'any';
        }

        return React.createElement(ReactFilterCombo, {
            ref: this.dropdownRef,
            singleSelect: true,
            label: this.props.label,
            value: value,
            idField: 'value',
            displayField: 'text',
            applyFilters: this.props.applyFilters,
            clearFilters: this.props.clearFilters,
            loadGrid: this.props.loadGrid,
            records: [{
                text: __d('modules','Yes'),
                value: '1'
            }, {
                text: __d('modules','No'),
                value: '0'
            }, {
                text: __d('modules','Any'),
                value: 'any'
            }]
        });
    }
}

ReactFilterBoolean.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};